import { render, staticRenderFns } from "./customer-receipt.vue?vue&type=template&id=662b0356"
import script from "./customer-receipt.vue?vue&type=script&lang=js"
export * from "./customer-receipt.vue?vue&type=script&lang=js"
import style0 from "./customer-receipt.vue?vue&type=style&index=0&id=662b0356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports